import { Link } from "react-router-dom";

const TitleBarBackButton = ({className="", to}) => {


    return (
        <Link className={"hov-bg-black d-flex rounded-circle p-1 "+className} to={to}>
            <box-icon size="md" color='white' type='solid' name='left-arrow-alt'></box-icon>
        </Link>
    );
}

export default TitleBarBackButton;